import { createStore } from "vuex";
import auth from "./modules/auth";
import claimDeclarations from "@/store/modules/claimDeclarations";
import notifications from "./modules/notifications";
import store from "./modules/store";
import customer from "./modules/customer";
import iban from "./modules/iban";
import navigation from "./modules/navigation";
import VuexPersistence from "vuex-persist";
import claims from "@/store/modules/claims.js";
import claimQuotations from "@/store/modules/claimQuotations.js";
import claimInvoices from "@/store/modules/claimInvoices.js";
import plan from "./modules/plan";
import leads from "./modules/leads";
import claimDeductibles from "@/store/modules/claims/claimDeductibles.js";
import finalSettlements from "@/store/modules/claims/finalSettlements.js";
import planSales from "@/store/modules/planSales.js";
import planSaleBillings from "@/store/modules/planSaleBillings.js";
import cancellations from "@/store/modules/cancellations.js";
import contractMigrationConsents from "@/store/modules/contractMigrationConsents.js";

const vuexLocal = new VuexPersistence({
  key: "vuex_customer",
  storage: window.localStorage,
});

export default createStore({
  modules: {
    auth,
    claimDeclarations,
    notifications,
    store,
    customer,
    iban,
    navigation,
    claims,
    claimQuotations,
    claimInvoices,
    plan,
    leads,
    claimDeductibles,
    finalSettlements,
    planSales,
    planSaleBillings,
    cancellations,
    contractMigrationConsents,
  },
  plugins: [vuexLocal.plugin],
});
